export default __webpack_public_path__ + "static/media/00.df67ea66.jpg";